webpackJsonp([0],{

/***/ "7Epj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleOverview_vue__ = __webpack_require__("R00o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4aeaf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleOverview_vue__ = __webpack_require__("99ne");
function injectStyle (ssrContext) {
  __webpack_require__("wMiq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f4aeaf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f4aeaf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "99ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"article-overview"},[_c('div',{staticClass:"article-overview__container"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CQmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce__ = __webpack_require__("HhAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'overview',
  data: function data() {
    return {
      error: {
        text: 'Please fill in your bodyweight.',
        type: 'bodyweight'
      },
      measurement: 'KG',
      gender: 'Male',
      bodyweight: null,
      calculate: 'Weight',
      squat: null,
      bench: null,
      deadlift: null,
      points: null,
      calculatedWilks: null,
      calculatedWeight: 0
    };
  },

  methods: {
    debounce: __WEBPACK_IMPORTED_MODULE_0_debounce___default.a,
    baywatch: function baywatch(props, watcher) {
      var iterator = function iterator(prop) {
        this.$watch(prop, watcher);
      };
      props.forEach(iterator, this);
    },
    coeff: function coeff() {
      // We need the bodyweight to make the coeff calculation
      if (!this.bodyweight) {
        this.error = {
          text: 'Please fill in your bodyweight.',
          type: 'bodyweight'
        };
        return;
      }

      // Reset the error
      this.error = {
        text: null,
        type: null

        // Let's see what gender and measurement units we're going to use
      };var gender = this.gender;
      var measurement = this.measurement;

      // Set the bodyweight based on the measurement units
      var bw = this.bodyweight;
      if (measurement === 'LBS') {
        bw = bw / 2.2;
      }

      // Set up all the constants for the formula
      var a = gender === 'Male' ? -216.0475144 : 594.31747775582;
      var b = gender === 'Male' ? 16.2606339 : -27.23842536447;
      var c = gender === 'Male' ? -0.002388645 : 0.82112226871;
      var d = gender === 'Male' ? -0.00113732 : -0.00930733913;
      var e = gender === 'Male' ? 7.01863e-06 : 4.731582e-05;
      var f = gender === 'Male' ? -1.291e-08 : -9.054e-08;

      // Coeff formula
      var coeff = 500 / (a + b * bw + c * Math.pow(bw, 2) + d * Math.pow(bw, 3) + e * Math.pow(bw, 4) + f * Math.pow(bw, 5));

      // Return the coeff
      return coeff;
    },

    calculateWilks: __WEBPACK_IMPORTED_MODULE_0_debounce___default()(function () {
      if (this.calculate !== 'Weight') {
        return;
      }

      // We need the bodyweight to make the coeff calculation
      if (!this.bodyweight) {
        this.error = {
          text: 'Please fill in your bodyweight.',
          type: 'bodyweight'
        };
        return;
      }

      // Not all are needed, but we need at least one of them
      if (!this.squat && !this.bench && !this.deadlift) {
        this.error = {
          text: 'Please fill in your lifted weights.',
          type: 'total'
        };
        return;
      }

      // Get the total
      var total = Number(this.squat) + Number(this.bench) + Number(this.deadlift);

      // Reset the error
      this.error = {
        text: null,
        type: null

        // Let's see what measurement unit we're going to use
      };var measurement = this.measurement;
      // Convert the total based on the measurement units
      if (measurement === 'LBS') {
        total = total / 2.2;
      }

      // Coeff formula
      var coeff = this.coeff();
      var wilks = coeff * total;

      // Return Wilks points
      this.calculatedWilks = wilks.toFixed(2);
    }, 100),
    calculateWeight: __WEBPACK_IMPORTED_MODULE_0_debounce___default()(function () {
      if (this.calculate !== 'Wilks') {
        return;
      }

      // We need the bodyweight to make the coeff calculation
      if (!this.bodyweight) {
        this.error = {
          text: 'Please fill in your bodyweight.',
          type: 'bodyweight'
        };
        return;
      }

      // We need the desired Wilks points if we want to make the calculation
      if (!this.points) {
        this.error = {
          text: 'Please fill in your desired Wilks.',
          type: 'wilks'
        };
        return;
      }

      // Reset the error
      this.error = {
        text: null,
        type: null

        // Set the points constant
      };var points = this.points;

      // Coeff formula
      var coeff = this.coeff();

      // Total in KG
      var total = points / coeff;

      // Let's see what measurement unit we're going to use
      var measurement = this.measurement;
      // Convert the total based on the measurement units
      if (measurement === 'LBS') {
        total = total * 2.2;
      }

      // Return the total
      this.calculatedWeight = total.toFixed(2);
    }, 100)
  },
  created: function created() {
    this.baywatch(['bodyweight', 'measurement', 'gender', 'calculate', 'squat', 'bench', 'deadlift'], this.calculateWilks.bind(this));
    this.baywatch(['bodyweight', 'measurement', 'gender', 'calculate', 'points'], this.calculateWeight.bind(this));
  },

  computed: {}
});

/***/ }),

/***/ "ETxe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmnf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"overview"},[_c('div',{staticClass:"overview__container"},[_c('ul',{staticClass:"overview__list"},[_c('li',{staticClass:"overview__item o-item o-item--radio"},[_c('span',{staticClass:"o-item__label-text o-item--radio__label-text"},[_vm._v("\n          Weight unit\n        ")]),_vm._v(" "),_c('label',{staticClass:"o-item__label o-item--radio__label",attrs:{"for":"measurement_kg"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.measurement),expression:"measurement"}],staticClass:"o-item__input o-item--radio__input",attrs:{"value":"KG","name":"measurement","id":"measurement_kg","type":"radio"},domProps:{"checked":_vm._q(_vm.measurement,"KG")},on:{"change":function($event){_vm.measurement="KG"}}}),_vm._v(" "),_c('span',{staticClass:"o-item__text o-item--radio__text"},[_vm._v("\n            KG\n          ")])]),_vm._v(" "),_c('label',{staticClass:"o-item__label o-item--radio__label",attrs:{"for":"measurement_lbs"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.measurement),expression:"measurement"}],staticClass:"o-item__input o-item--radio__input",attrs:{"value":"LBS","id":"measurement_lbs","type":"radio"},domProps:{"checked":_vm._q(_vm.measurement,"LBS")},on:{"change":function($event){_vm.measurement="LBS"}}}),_vm._v(" "),_c('span',{staticClass:"o-item__text o-item--radio__text"},[_vm._v("\n            LBS\n          ")])])]),_vm._v(" "),_c('li',{staticClass:"overview__item o-item o-item--radio"},[_c('span',{staticClass:"o-item__label-text o-item--radio__label-text"},[_vm._v("\n          Gender\n        ")]),_vm._v(" "),_c('label',{staticClass:"o-item__label o-item--radio__label",attrs:{"for":"gender_male"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],staticClass:"o-item__input o-item--radio__input",attrs:{"value":"Male","name":"gender","id":"gender_male","type":"radio"},domProps:{"checked":_vm._q(_vm.gender,"Male")},on:{"change":function($event){_vm.gender="Male"}}}),_vm._v(" "),_c('span',{staticClass:"o-item__text o-item--radio__text"},[_vm._v("\n            Male\n          ")])]),_vm._v(" "),_c('label',{staticClass:"o-item__label o-item--radio__label",attrs:{"for":"gender_female"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],staticClass:"o-item__input o-item--radio__input",attrs:{"value":"Female","name":"gender","id":"gender_female","type":"radio"},domProps:{"checked":_vm._q(_vm.gender,"Female")},on:{"change":function($event){_vm.gender="Female"}}}),_vm._v(" "),_c('span',{staticClass:"o-item__text o-item--radio__text"},[_vm._v("\n            Female\n          ")])])]),_vm._v(" "),_c('li',{staticClass:"overview__item o-item o-item--number"},[_c('label',{staticClass:"o-item__label o-item--number__label",attrs:{"for":"bodyweight"}},[_c('span',{staticClass:"o-item__label-text o-item--number__label-text",class:{
              'o-item__label-text--active': !!(_vm.bodyweight),
              'o-item__label-text--error': _vm.error.type === 'bodyweight'
            }},[_vm._v("\n            Bodyweight\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.bodyweight),expression:"bodyweight",modifiers:{"number":true}}],staticClass:"o-item__input o-item--number__input",class:{
              'o-item__input--error': _vm.error.type === 'bodyweight'
            },attrs:{"type":"number","id":"bodyweight","value":"","placeholder":"75","name":"bodyweight"},domProps:{"value":(_vm.bodyweight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bodyweight=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('li',{staticClass:"overview__item o-item o-item--radio"},[_c('span',{staticClass:"o-item__label-text o-item--radio__label-text"},[_vm._v("\n          Calculate by\n        ")]),_vm._v(" "),_c('label',{staticClass:"o-item__label o-item--radio__label",attrs:{"for":"calculate_weight"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.calculate),expression:"calculate",modifiers:{"number":true}}],staticClass:"o-item__input o-item--radio__input",attrs:{"value":"Weight","name":"calculate","id":"calculate_weight","type":"radio"},domProps:{"checked":_vm._q(_vm.calculate,_vm._n("Weight"))},on:{"change":function($event){_vm.calculate=_vm._n("Weight")}}}),_vm._v(" "),_c('span',{staticClass:"o-item__text o-item--radio__text"},[_vm._v("\n            Total\n          ")])]),_vm._v(" "),_c('label',{staticClass:"o-item__label o-item--radio__label",attrs:{"for":"calculate_wilks"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.calculate),expression:"calculate",modifiers:{"number":true}}],staticClass:"o-item__input o-item--radio__input",attrs:{"value":"Wilks","name":"calculate","id":"calculate_wilks","type":"radio"},domProps:{"checked":_vm._q(_vm.calculate,_vm._n("Wilks"))},on:{"change":function($event){_vm.calculate=_vm._n("Wilks")}}}),_vm._v(" "),_c('span',{staticClass:"o-item__text o-item--radio__text"},[_vm._v("\n            Wilks\n          ")])])]),_vm._v(" "),(_vm.calculate === 'Weight')?_c('li',{staticClass:"overview__item o-item o-item--number"},[_c('label',{staticClass:"o-item__label o-item--number__label",attrs:{"for":"squat"}},[_c('span',{staticClass:"o-item__label-text o-item--number__label-text",class:{
              'o-item__label-text--active': !!(_vm.squat),
              'o-item__label-text--error': _vm.error.type === 'total'
            }},[_vm._v("\n            Squat\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.squat),expression:"squat",modifiers:{"number":true}}],staticClass:"o-item__input o-item--number__input",class:{
              'o-item__input--error': _vm.error.type === 'total'
            },attrs:{"type":"number","id":"squat","value":"","placeholder":"140","name":"squat"},domProps:{"value":(_vm.squat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.squat=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])]):_vm._e(),_vm._v(" "),(_vm.calculate === 'Weight')?_c('li',{staticClass:"overview__item o-item o-item--number"},[_c('label',{staticClass:"o-item__label o-item--number__label",attrs:{"for":"bench"}},[_c('span',{staticClass:"o-item__label-text o-item--number__label-text",class:{
              'o-item__label-text--active': !!(_vm.bench),
              'o-item__label-text--error': _vm.error.type === 'total'
            }},[_vm._v("\n            Bench\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.bench),expression:"bench",modifiers:{"number":true}}],staticClass:"o-item__input o-item--number__input",class:{
              'o-item__input--error': _vm.error.type === 'total'
            },attrs:{"type":"number","id":"bench","value":"","placeholder":"100","name":"bench"},domProps:{"value":(_vm.bench)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bench=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])]):_vm._e(),_vm._v(" "),(_vm.calculate === 'Weight')?_c('li',{staticClass:"overview__item o-item o-item--number"},[_c('label',{staticClass:"o-item__label o-item--number__label",attrs:{"for":"deadlift"}},[_c('span',{staticClass:"o-item__label-text o-item--number__label-text",class:{
              'o-item__label-text--active': !!(_vm.deadlift),
              'o-item__label-text--error': _vm.error.type === 'total'
            }},[_vm._v("\n            Deadlift\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.deadlift),expression:"deadlift",modifiers:{"number":true}}],staticClass:"o-item__input o-item--number__input",class:{
              'o-item__input--error': _vm.error.type === 'total'
            },attrs:{"type":"number","id":"deadlift","value":"","placeholder":"180","name":"deadlift"},domProps:{"value":(_vm.deadlift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.deadlift=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])]):_vm._e(),_vm._v(" "),(_vm.calculate === 'Wilks')?_c('li',{staticClass:"overview__item o-item o-item--number"},[_c('label',{staticClass:"o-item__label o-item--number__label",attrs:{"for":"points"}},[_c('span',{staticClass:"o-item__label-text o-item--number__label-text",class:{
              'o-item__label-text--active': !!(_vm.points),
              'o-item__label-text--error': _vm.error.type === 'wilks'
            }},[_vm._v("\n            Points\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.points),expression:"points",modifiers:{"number":true}}],staticClass:"o-item__input o-item--number__input",class:{
              'o-item__input--error': _vm.error.type === 'wilks'
            },attrs:{"type":"number","id":"points","placeholder":"350","name":"points"},domProps:{"value":(_vm.points)},on:{"input":function($event){if($event.target.composing){ return; }_vm.points=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])]):_vm._e()]),_vm._v(" "),(_vm.error.text)?_c('p',{staticClass:"error"},[_c('span',{staticClass:"error__text"},[_vm._v(_vm._s(_vm.error.text))])]):_vm._e(),_vm._v(" "),(!_vm.error.text)?[(_vm.calculate === 'Weight')?_c('div',{staticClass:"overview__result overview__result--weight result"},[_c('div',{staticClass:"result__label"},[_vm._v("\n          Wilks\n        ")]),_vm._v(" "),_c('div',{staticClass:"result__numbers"},[_vm._v("\n          "+_vm._s(_vm.calculatedWilks)+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.calculate === 'Wilks')?_c('div',{staticClass:"overview__result overview__result--wilks result"},[_c('div',{staticClass:"result__label"},[_vm._v("\n          Total\n        ")]),_vm._v(" "),_c('div',{staticClass:"result__numbers"},[_vm._v("\n          "+_vm._s(_vm.calculatedWeight)+" "+_vm._s(_vm.measurement)+"\n        ")])]):_vm._e()]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KiQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vheader_vue__ = __webpack_require__("Na56");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8157fc14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vheader_vue__ = __webpack_require__("Z6ge");
function injectStyle (ssrContext) {
  __webpack_require__("ETxe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8157fc14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vheader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8157fc14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vheader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L851":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Vheader'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('keep-alive',{attrs:{"include":"overview"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d2b4e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("L851");
function injectStyle (ssrContext) {
  __webpack_require__("OBJx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d2b4e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Na56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-header',
  data: function data() {
    return {
      logo: 'Wilks Score'
    };
  },

  computed: {
    home: function home() {
      return this.$route.name === 'Overview';
    }
  }
});

/***/ }),

/***/ "OBJx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PD0s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R00o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'article-overview',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Overview_Overview__ = __webpack_require__("gAgx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ArticleOverview_ArticleOverview__ = __webpack_require__("7Epj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ArticleDetail_ArticleDetail__ = __webpack_require__("zatO");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/',
    name: 'Overview',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Overview_Overview__["a" /* default */]
  }, {
    path: '/articles',
    name: 'Articles',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ArticleOverview_ArticleOverview__["a" /* default */]
  }, {
    path: '/what-is-wilks',
    name: 'Article',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ArticleDetail_ArticleDetail__["a" /* default */]
  }, {
    path: '*',
    redirect: '/'
  }]
}));

/***/ }),

/***/ "Z6ge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('nav',{staticClass:"header__container"},[_c('span',{staticClass:"header__logo",class:{
        'header__logo--active': _vm.home
      }},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.logo))])],1),_vm._v(" "),_c('ul',{staticClass:"header__menu"},[_c('li',{staticClass:"header__item",class:{
          'header__item--active': !_vm.home
        }},[_c('router-link',{attrs:{"to":"/what-is-wilks"}},[_vm._v("What is Wilks?")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b/9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'article-detail',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "gAgx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("CQmj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fefa3b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("Jmnf");
function injectStyle (ssrContext) {
  __webpack_require__("qlBU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fefa3b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fefa3b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qlBU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wMiq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wqks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"article-detail"},[_c('div',{staticClass:"article-detail__container"},[_c('h1',{staticClass:"article-detail__title"},[_vm._v("What is Wilks?")]),_vm._v(" "),_c('div',{staticClass:"article-detail__content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("Calculate your Wilks "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("here")]),_vm._v(".")],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You might have seen the term "),_c('i',[_vm._v("“Wilks”")]),_vm._v(" being used at powerlifting meets and all around the internet — on this website, for instance! But, what is Wilks exactly?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Wilks is a widely used term in powerlifting, but is actually shorthand for Wilks Coefficient or Wilks Formula. The author of the formula is Robert Wilks, CEO of "),_c('a',{attrs:{"href":"https://powerliftingaustralia.com/","target":"_blank"}},[_vm._v("Powerlifting Australia")]),_vm._v(". The current version of the Wilks calculation is being used in the "),_c('a',{attrs:{"href":"http://www.powerlifting-ipf.com/","target":"_blank"}},[_vm._v("International Powerlifting Federation (IPF)")]),_vm._v(" since 1998.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("When using the Wilks calculation, only two variables are needed of the lifter: bodyweight and total amount of weight lifted. The result of the calculation is the relative strength of the lifter — which is often called the Wilks score/points. This result is useful when comparing multiple lifters with each other. A 105kg male lifter (with a 700kg total) might have a larger "),_c('b',[_vm._v("absolute strength")]),_vm._v(", when being compared with a 66kg male lifter (with a 600kg total), but the 66kg lifter has a larger "),_c('b',[_vm._v("relative strength")]),_vm._v(" (418 Wilks vs. 471 Wilks).")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_Vheader__ = __webpack_require__("KiQg");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Vheader: __WEBPACK_IMPORTED_MODULE_0__components_Header_Vheader__["a" /* default */]
  }
});

/***/ }),

/***/ "zatO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleDetail_vue__ = __webpack_require__("b/9C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0e5921_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleDetail_vue__ = __webpack_require__("wqks");
function injectStyle (ssrContext) {
  __webpack_require__("PD0s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a0e5921"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0e5921_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3b4ecc48c2761619f9df.js